import moment from "moment";
import { MAX_DAYS_IN_ON_DEMAND_EVENT } from "config/app";

export const canAddDaysToEvent = (start, end) =>
  moment(end)
    .add(1, "day")
    .startOf("day")
    .diff(start, "days") <= MAX_DAYS_IN_ON_DEMAND_EVENT;
